var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "validation-observer",
    { ref: "observer", attrs: { tag: "div" } },
    [
      _c("app-divider", {
        staticClass: "mb-30px",
        attrs: { label: "Dados do Imóvel" }
      }),
      _c(
        "el-row",
        { staticClass: "labelDiv", attrs: { gutter: 30 } },
        [
          _c(
            "el-col",
            { staticClass: "inputDiv", attrs: { span: 8 } },
            [
              _c("validation-provider", {
                attrs: {
                  rules: "required",
                  name: _vm.nomeAba + "/Denominação Imóvel"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(ref) {
                      var errors = ref.errors
                      return [
                        _c("app-label", {
                          attrs: {
                            label: "Denominação do Imóvel: ",
                            required: true
                          }
                        }),
                        _c("el-input", {
                          staticClass: "input",
                          class: { erro: errors.length },
                          attrs: { name: "denominacao" },
                          model: {
                            value: _vm.imovel.denominacao,
                            callback: function($$v) {
                              _vm.$set(_vm.imovel, "denominacao", $$v)
                            },
                            expression: "imovel.denominacao"
                          }
                        }),
                        _c("span", { staticClass: "help erro" }, [
                          _vm._v(_vm._s(errors[0]))
                        ])
                      ]
                    }
                  }
                ])
              })
            ],
            1
          ),
          _c(
            "el-col",
            { staticClass: "inputDiv", attrs: { span: 8 } },
            [
              _c("app-label", {
                attrs: { label: "Matrícula: ", required: false }
              }),
              _c("el-input", {
                staticClass: "input",
                attrs: { name: "numeroMatricula" },
                model: {
                  value: _vm.imovel.numeroMatricula,
                  callback: function($$v) {
                    _vm.$set(_vm.imovel, "numeroMatricula", $$v)
                  },
                  expression: "imovel.numeroMatricula"
                }
              })
            ],
            1
          ),
          _c(
            "el-col",
            { staticClass: "inputDiv", attrs: { span: 8 } },
            [
              _c("app-label", {
                attrs: {
                  label: "Averbação Transferência de domínio: ",
                  required: false
                }
              }),
              _c("el-input", {
                staticClass: "input",
                attrs: { name: "averbacaoTransferenciaDominio" },
                model: {
                  value: _vm.imovel.averbacaoTransferenciaDominio,
                  callback: function($$v) {
                    _vm.$set(_vm.imovel, "averbacaoTransferenciaDominio", $$v)
                  },
                  expression: "imovel.averbacaoTransferenciaDominio"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-row",
        { staticClass: "labelDiv mt-10px", attrs: { gutter: 30 } },
        [
          _c(
            "el-col",
            { staticClass: "inputDiv", attrs: { span: 8 } },
            [
              _c("app-label", {
                attrs: {
                  label: "Averbação Georreferenciamento: ",
                  required: false
                }
              }),
              _c("el-input", {
                staticClass: "input",
                attrs: { name: "averbacaoGeorreferenciamento" },
                model: {
                  value: _vm.imovel.averbacaoGeorreferenciamento,
                  callback: function($$v) {
                    _vm.$set(_vm.imovel, "averbacaoGeorreferenciamento", $$v)
                  },
                  expression: "imovel.averbacaoGeorreferenciamento"
                }
              })
            ],
            1
          ),
          _c(
            "el-col",
            { staticClass: "inputDiv", attrs: { span: 8 } },
            [
              _c("app-label", { attrs: { label: "CNS: ", required: false } }),
              _c("el-input", {
                staticClass: "input",
                attrs: { name: "cns" },
                model: {
                  value: _vm.imovel.cnsMatricula,
                  callback: function($$v) {
                    _vm.$set(_vm.imovel, "cnsMatricula", $$v)
                  },
                  expression: "imovel.cnsMatricula"
                }
              })
            ],
            1
          ),
          _c(
            "el-col",
            { staticClass: "inputDiv", attrs: { span: 8 } },
            [
              _c("app-label", { attrs: { label: "SNCR: ", required: false } }),
              _c("el-input", {
                staticClass: "input",
                attrs: { name: "sncr" },
                model: {
                  value: _vm.imovel.sncr,
                  callback: function($$v) {
                    _vm.$set(_vm.imovel, "sncr", $$v)
                  },
                  expression: "imovel.sncr"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-row",
        { staticClass: "labelDiv mt-10px", attrs: { gutter: 30 } },
        [
          _c(
            "el-col",
            { staticClass: "inputDiv", attrs: { span: 8 } },
            [
              _c("app-label", { attrs: { label: "NIRF: ", required: false } }),
              _c("el-input", {
                staticClass: "input",
                attrs: { name: "nirf" },
                model: {
                  value: _vm.imovel.nirf,
                  callback: function($$v) {
                    _vm.$set(_vm.imovel, "nirf", $$v)
                  },
                  expression: "imovel.nirf"
                }
              })
            ],
            1
          ),
          _c(
            "el-col",
            { staticClass: "inputDiv", attrs: { span: 8 } },
            [
              _c("app-label", {
                attrs: { label: "Cadastro CAR: ", required: false }
              }),
              _c("el-input", {
                directives: [
                  {
                    name: "mask",
                    rawName: "v-mask",
                    value: _vm.carMask,
                    expression: "carMask"
                  }
                ],
                staticClass: "input",
                attrs: { name: "numeroReciboCar" },
                model: {
                  value: _vm.imovel.numeroReciboCar,
                  callback: function($$v) {
                    _vm.$set(_vm.imovel, "numeroReciboCar", $$v)
                  },
                  expression: "imovel.numeroReciboCar"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c("app-divider", {
        staticClass: "mb-30px",
        attrs: { label: "Localização do Imóvel" }
      }),
      _c("validation-provider", {
        attrs: { name: "Georreferenciamento/Geometria" },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function(ref) {
              var errors = ref.errors
              return [
                _c("mapa-analise-geomensor", {
                  attrs: {
                    localizacoes: _vm.geometrias,
                    tipoCadastro: "RF",
                    name: "Geometria",
                    idMapa: "mapaAnaliseGeomensor",
                    errors: errors,
                    addOrtoFotos: true
                  },
                  on: {
                    shapefileUploaded: _vm.setShapefile,
                    shapefileRemoved: _vm.removeShapefile
                  },
                  model: {
                    value: _vm.geometrias,
                    callback: function($$v) {
                      _vm.geometrias = $$v
                    },
                    expression: "geometrias"
                  }
                })
              ]
            }
          }
        ])
      }),
      _c("app-documentos", {
        attrs: {
          maxSize: 25,
          "valid-extensions": ["doc", "docx", "jpeg", "jpg", "pdf", "png"],
          documentos: _vm.imovel.documentos,
          tiposDocumentos: _vm.documentos,
          tiposDocumentosObrigatorios: _vm.documentosObrigatorio,
          observer: this.$refs.observer,
          aba: "Imovel",
          titulo: "Documentos do Imóvel"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-25617182", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-25617182","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/analise/components/cadastroRf/AppFormularioImovel.vue
// module id = null
// module chunks = 